import {lazyRegister} from "@core/lazyRegister";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {ProductColor} from "@/models";

export class ProductColorService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetBySku(sku: string, langCode: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<ProductColor[]>(`/api/ProductColor/${sku}`, {langCode}, cancelToken);
    };

}


lazyRegister.service('ProductColorService', ProductColorService);